import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost' | 'white';
  size?: 'sm' | 'default' | 'lg';
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'default',
  size = 'default',
  ...props
}, ref) => {
  return <button ref={ref} className={cn('inline-flex items-center justify-center whitespace-nowrap rounded-none text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-400 disabled:pointer-events-none disabled:opacity-50', {
    'bg-black text-white hover:bg-gray-800': variant === 'default',
    'border border-gray-200 bg-transparent hover:bg-gray-50 text-black': variant === 'outline',
    'hover:bg-gray-100 text-black': variant === 'ghost',
    'bg-white text-black hover:bg-gray-100': variant === 'white',
    'h-9 px-4 py-2': size === 'sm',
    'h-11 px-6 py-2': size === 'default',
    'h-14 px-8 py-3 text-base': size === 'lg'
  }, className)} {...props} data-id="element-251" />;
});
Button.displayName = 'Button';